import './../AuthPages.scss';
import './LoginPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import update from "immutability-helper";

import { clearCredentials, login, setCredentials } from 'containers/Auth/store/actions';

import A from 'components/A';
import LoginForm from './LoginForm';
import PageContent from 'components/PageContent';

class LoginPage extends React.Component {
    componentDidMount() {
        document.body.classList.add('auth-page');
        document.body.classList.add('login-page');

        if(this.props.auth.token && this.props.auth.user && this.props.auth.user.id) {
            this.props.changeLocation(this.props.auth.user.company != null ? '/freelancers' : '/account/profile')
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
        document.body.classList.remove('login-page');
    }

    handleChange(name, value) {
        let newCredentialsObj = update(this.props.auth.credentials, {});
        newCredentialsObj[name] = value;
        this.props.setCredentials(newCredentialsObj);
    }

    handleSubmit(isValid) {
        if(isValid === true) {
            this.props.login()
                .then((res) => {
                    console.log(res, res.status);
                    let redirectString = localStorage.getItem('login_redirect');
                    let redirectItems = redirectString ? redirectString.split('||') : null;
                    let redirect = res.data.data.user.company != null ? '/freelancers' : '/account/profile';
                    if(redirectItems && new Date().getTime() - parseInt(redirectItems[1], 10) <= 300000) {
                        redirect = redirectItems[0];
                    }
                    localStorage.removeItem('login_redirect');
                    this.props.changeLocation(redirect);
                    this.props.clearCredentials();
                })
        }
    }

    render() {
        return (
            <PageContent className="login-content">
                <div className="login-form--wrapper auth-form--wrapper">
                    <LoginForm
                        credentials={this.props.auth.credentials}
                        error={this.props.auth.loginError}
                        handleChange={this.handleChange.bind(this)}
                        isFetching={this.props.auth.isAuthenticating}
                        onInvalid={this.handleSubmit.bind(this, false)}
                        onValid={this.handleSubmit.bind(this, true)}
                    />

                    <div className="auth-page__links">
                        <A to="/forgot-password">Reset Password</A> / <A to="/request-invitation">Request Invitation</A>
                    </div>
                </div>
            </PageContent>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearCredentials: () => dispatch(clearCredentials()),
        login: () => dispatch(login()),
        setCredentials: (credentialsObj) => dispatch(setCredentials(credentialsObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/LoginPage/index.js